// src/services/contentService.ts
import { useState, useCallback } from 'react';
import { useAppDispatch } from '../store/hooks';
import { fetchContent, updateContent } from '../store/slices/contentSlice';
import { WebsiteContent } from '../types';


export const useContentService = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const loadContent = useCallback(async () => {
    setLoading(true);
    try {
      await dispatch(fetchContent()).unwrap();
    } catch (error) {
      console.error('Failed to load content:', error);
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  const saveContent = useCallback(
    async (content: WebsiteContent) => {
      setLoading(true);
      try {
        // In production, this would save to your backend
        // await api.post('/content', content);
        dispatch(updateContent(content));
        return true;
      } catch (error) {
        console.error('Failed to save content:', error);
        return false;
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  return {
    loadContent,
    saveContent,
    loading,
  };
};